import { TVStyleProps } from '../../style-system';
import { AvatarGroup } from '../avatar';
import { FlexBox } from '../flex-box';
import { Link } from '../link';
import { Text } from '../text';

import { cardStyles } from './card.styles';

export type CardProps = React.PropsWithChildren<
    TVStyleProps<typeof cardStyles> & {
        href?: string;
        variant?: 'avatar-text';
        avatarImg?: string | null;
        avatarName?: string;
        title?: React.ReactNode;
        subtitle?: React.ReactNode;
    }
>;

export const Card = ({ children, variant, avatarImg, avatarName, title, subtitle, ...rest }: CardProps) => {
    if (rest.href) {
        return (
            <Link.Base className={cardStyles(rest)} href={rest.href}>
                {children}
            </Link.Base>
        );
    }
    if (variant === 'avatar-text') {
        return (
            <FlexBox alignItems="center" gap="md">
                <AvatarGroup
                    stack="asc"
                    size={32}
                    avatars={[
                        {
                            src: avatarImg ?? '',
                            alt: avatarName?.toUpperCase(),
                        },
                    ]}
                />
                <FlexBox col>
                    <Text weight="medium" size="sm">
                        {title}
                    </Text>
                    <Text size="sm" color="deselect">
                        {subtitle}
                    </Text>
                </FlexBox>
            </FlexBox>
        );
    }
    return <div className={cardStyles(rest)}>{children}</div>;
};
